import { useEffect, useState } from 'react';
import ProductCard from './organisms/ProductCard';
import { Product } from '../../@types/Products.type';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import TogglePeriodicity from './organisms/TogglePeriodicity';
import { useMediaQuery } from '@mui/material';
import PlanOverview from './organisms/PlanOverview';

const SubscriptionsPlanSection = ({}: {}) => {
	const [subscriptionProducts, setSubscriptionProducts] = useState<
		Product[] | null
	>(null);

	const { products } = useSelector((state: RootState) => state.productList);
	const { samanthaAnalysis } = useSelector((state: RootState) => state.ai);

	const [isLoadingClickProduct, setIsLoadingClickProduct] = useState(false);

	const isMobile = useMediaQuery('(max-width: 768px)');

	useEffect(() => {
		const subscriptionProductsFiltered = products?.find(
			//@ts-ignore
			(item) => item?.name === 'Planes',
		)?.products;

		const suscriptionProductsWithRecommendedPlan =
			subscriptionProductsFiltered?.map((product) => {
				if (product.slug === samanthaAnalysis?.slug) {
					return { ...product, recommended: true };
				}
				return product;
			});

		if (suscriptionProductsWithRecommendedPlan) {
			//@ts-ignore
			const orderByPrice = suscriptionProductsWithRecommendedPlan.toSorted(
				(a: Product, b: Product) => a.price - b.price,
			);

			const orderByRecommended = orderByPrice.toSorted(
				(
					a: Product & { recommended: boolean },
					b: Product & { recommended: boolean },
				) => (a.recommended ? -1 : b.recommended ? 1 : 0),
			);

			if (isMobile) {
				setSubscriptionProducts(orderByRecommended);
			} else {
				setSubscriptionProducts(orderByPrice);
			}
		}
	}, [products, isMobile]);

	return (
		<div>
			<div className='w-full mx-auto max-w-[1200px]'>
				<>
					<PlanOverview
						title='Selecciona el plan que más se adecue a tu actividad económica'
						description='Todos nuestros planes están diseñados para quitarte el estrés de cumplir con tus obligaciones fiscales con la ayuda de nuestros contadores expertos y nuestra tecnología.'
					/>
					<TogglePeriodicity
						className={`flex items-center gap-2 w-full md:-mt-6 justify-center md:justify-end py-4 fixed top-10 md:!top-auto md:relative md:left-auto md:right-auto bg-h-neutral-94 z-10`}
					/>
					<div className='flex flex-col lg:flex-row items-start gap-2 sm:gap-3 xl:gap-8 mt-2 px-3 mb-4'>
						{subscriptionProducts?.map((product, index) => (
							<ProductCard
								product={product}
								key={`product-${index}`}
								recommended={product.slug === samanthaAnalysis?.slug}
								className='lg:min-h-[760px]'
								isLoadingClickProduct={isLoadingClickProduct}
								setIsLoadingClickProduct={setIsLoadingClickProduct}
							/>
						))}
					</div>
				</>
			</div>
		</div>
	);
};

export default SubscriptionsPlanSection;
